import { ConfirmJointHolderFormModel } from './Models/ConfirmJointHolderFormModel';
import { SecuredClient } from '../../../Core/Api/SecuredClient';
import { SlimUser, ApproveAccountCommandRequest } from '../../../Core/Api/Api';

export class ConfirmJointHolderFormHandler {
    props: any;
    constructor(props) {
        this.props = props;
    }

    ConfirmJointHolder(email: string, token: string, trn: string, firstName: string, lastName: string): Promise<Boolean | undefined> {
        const client = new SecuredClient();
        const request = new ApproveAccountCommandRequest();
        request.firstName = firstName;
        request.lastName = lastName;
        request.linkedToken = token;
        request.trn = trn;
        client.showLoading = true;
        client.handleGeneralError = true;
        return client.approveAccountHolder(request).then(x => {
            // the user is logged in. store access token
            // and user object for reference
            // if (x.accessToken && x.loggedIn) {
            //   //sessionStorage.setItem('token', x.accessToken);
            // }


            return true;
        });
    }
}






